import React, { useState, useEffect } from 'react';
import { Card, CardHeader, CardContent, Grid } from '@material-ui/core';
import { IoLocationSharp, IoCall, IoMail, IoPrintSharp, IoLogoFacebook, IoLogoTwitter } from 'react-icons/io5';
import translate from '../../translation.json';
import { lang } from "../../config/app.config";
import { fetchBranchBySlug } from '../../services/branchs.service';
import Branch from '../../models/branch.model';
import staff from '../../models/staff.model';
import { useSelector } from 'react-redux';
import { TranslationState } from "../../store/ActionReducers/translation.actionreducer";
import { fetchStaffs } from '../../services/staff.service';

// interface State{
//   staff:{
//     staffs:Array<staff>,
//     // loading:boolean,
//     // meta:pageMeta
//   }
// }

const ContactDetails: React.FC = () => {

  const [branch, setBranch] = useState<Branch | undefined>(undefined);
  const [staffs, setStaffs] = useState<[staff] | undefined>(undefined);
  const state = useSelector((state: { translation: TranslationState }) => state.translation);

  const init = async () => {
    fetchMembers();
    const branch = await fetchBranchBySlug('head-office');
    setBranch(branch);
  }

  const fetchMembers = async () => {
    const data = await fetchStaffs('head-office', 'member?contact_page=true');
    setStaffs(data);
  }

  useEffect(() => {
    init();
  }, []); //eslint-disable-line

  console.log('branch here', branch)

  return (

    <Card>
      <CardHeader title={<><h4 className="text-center m-0 contact_us_title">{translate.translation[lang].contact_us}</h4></>} className="card-header-primary" />
      <CardContent className="bg-primary">
        <Grid container spacing={2} >

          {
            branch ?
              <Grid xs={12} md={12} lg={5}>
                <ul className="contact-list mb-1">
                  <h4 className="ecn-title text-13">{translate.translation[lang].election_commission}</h4>
                  <li> <IoLocationSharp className="mr-05" />{branch?.address?.municipality ? `${branch?.address?.municipality} ,` : ''} <span className="dev-number">{`${branch?.address?.ward ? branch?.address?.ward + ' ,' : ''}`}</span> {branch.district ? branch.district : branch.province}</li>
                  <li> <IoCall className="mr-05 " /><span>{translate.translation[lang].phone}:</span> <span className="dev-number">{branch.phone}</span></li>
                  <li> <IoPrintSharp className="mr-05 dev-number" /><span>{translate.translation[lang].fax}:</span> <span className="dev-number">{branch?.fax}</span> </li>
                  <li><IoMail className="mr-05" />{translate.translation[lang].email}: <a href="mailto:info@election.gov.np" className="ml-05 eng-number">{branch.email}</a></li>
                  <li><IoLogoFacebook className="mr-05" /><a href={branch?.facebook} className="ml-05" target="_blank" rel="noreferrer">{translate.translation[lang].facebook}</a></li>
                  <li><IoLogoTwitter className="mr-05" /><a href={branch?.twitter} className="ml-05" target="_blank" rel="noreferrer">{translate.translation[lang].twitter}</a></li>
                </ul>
              </Grid> : ""
          }
          <Grid xs={12} md={12} lg={7}>
            {staffs && staffs.length ? staffs?.map((staff, staffIndex) => {
              return (
                <>
                  <h4 className="ecn-title text-13">{staff?.designation}</h4>
                  <ul className="contact-list mb-1">
                    <li>{`${staff?.name}`}</li>
                    <li>{translate.translation[lang].phone}: <span className="dev-number">{staff?.contact ?? '-'}</span></li>
                    <li>{translate.translation[lang].email}: <a href={`mailto:${staff?.email}`} className="ml-05">{staff?.email ?? '-'}</a></li>
                  </ul>
                </>
              )
            }) : ""}
          </Grid>



        </Grid>
      </CardContent>
    </Card>

  );
}

export default ContactDetails;